import superagent from '@ott/superagent';

import format from 'date-fns/format';
import subDays from 'date-fns/subDays';

import T from '../types';

const formatDate = date => {
  return format(date, 'dd.MM.yyyy');
};

let currentReq = null;
export default (departureCode, destinationCode, startDate, endDate) => {
  return {
    promise: async () => {
      if (currentReq) {
        currentReq.abort();
      }

      const query = {
        city_from: departureCode,
        country_to: destinationCode,
        start_date: formatDate(startDate),
        // последняя дата начала за 3 дня до предельной даты календаря
        end_date: formatDate(subDays(endDate, 3)),
      };

      const {
        body: { result },
      } = await (currentReq = superagent.get('/_tours/getFlightsAndNights/').query(query));

      return result;
    },
    types: [T.GET_AVAILABLE_DATES, T.GET_AVAILABLE_DATES_SUCCESS, T.GET_AVAILABLE_DATES_FAIL],
  };
};
